(function facetGuard() {
  const attachFix = () => {
    document.querySelectorAll('.facets__heading--vertical').forEach(el => {
      if (el.dataset.bound) return;
      el.dataset.bound = 'true';
      el.addEventListener('click', e => {
        if (el.dataset.lock) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
        el.dataset.lock = '1';
        setTimeout(() => delete el.dataset.lock, 400);
      }, true);
    });
  };

  // Run once
  attachFix();

  // Watch for body replacement
  new MutationObserver(() => {
    attachFix();
  }).observe(document.body, { childList: true, subtree: true });
})();
